import { z } from "zod";

export const downtimeReasonProposalStatusSchema = z.enum(["PENDING", "APPROVED", "REJECTED"]);
export const downtimeReasonProposalDecisionSchema = z.enum(["APPROVED", "REJECTED"]);

export const downtimeReasonProposalSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(3).max(160),
  status: downtimeReasonProposalStatusSchema,
  submittedByName: z.string().min(1),
  lineName: z.string().min(1),
  createdAt: z.string().datetime({ offset: true }),
  groupName: z.string().min(1).nullable(),
  planned: z.boolean().nullable(),
  reviewNote: z.string().optional(),
  reasonCodeId: z.string().uuid().optional(),
});

export const downtimeReasonProposalListResponseSchema = z.object({
  items: z.array(downtimeReasonProposalSchema),
});

export const downtimeReasonProposalDecisionInputSchema = z.discriminatedUnion("decision", [
  z.object({
    decision: z.literal("APPROVED"),
    groupName: z.string().trim().min(3).max(80),
    planned: z.boolean(),
    note: z.string().trim().max(500).optional(),
  }),
  z.object({
    decision: z.literal("REJECTED"),
    note: z.string().trim().max(500).optional(),
  }),
]);

export type DowntimeReasonProposal = z.infer<typeof downtimeReasonProposalSchema>;
export type DowntimeReasonProposalDecisionInput = z.infer<typeof downtimeReasonProposalDecisionInputSchema>;
